import Scrollbars from "react-custom-scrollbars-2";

export const CustomScrollbar = ({ children }) => {
  return (
    <Scrollbars
      universal={false}
      autoHeight
      autoHeightMax={"100%"}
      autoHide
      autoHideTimeout={1000}
      autoHideDuration={200}
    >
      {children}
    </Scrollbars>
  );
};
